<template>
	<div class="box mb-0 w-100">
		<table class="table mb-0">
			<tbody>
				<tr>
					<td class="text-muted _600">Scores</td>
					<td v-if="firstScore" class="b-l text-center v-mid" style="min-width: 57px;">
						<i
							v-if="scoreTypeIconClass(firstScore.score_type)"
							class="fas fa-lg"
							:class="scoreTypeIconClass(firstScore.score_type)"
							v-tippy
							:title="scoreTypeTooltip(firstScore)"
						></i>
						<i
							v-if="!scoreTypeIconClass(firstScore.score_type)"
							class="material-icons"
							style="font-size: 28px; line-height: 30px;"
							v-tippy
							:title="scoreTypeTooltip(firstScore)"
							>{{ scoreTypeIcon(firstScore.score_type) }}</i
						>
					</td>
					<td v-if="secondScore" class="b-l text-center v-mid" style="min-width: 57px;">
						<i
							v-if="scoreTypeIconClass(secondScore.score_type)"
							class="fas fa-lg"
							:class="scoreTypeIconClass(secondScore.score_type)"
							v-tippy
							:title="scoreTypeTooltip(secondScore)"
						></i>
						<i
							v-if="!scoreTypeIconClass(secondScore.score_type)"
							class="material-icons"
							style="font-size: 28px; line-height: 30px;"
							v-tippy
							:title="scoreTypeTooltip(secondScore)"
							>{{ scoreTypeIcon(secondScore.score_type) }}</i
						>
					</td>
					<td v-if="resScore" class="b-l text-center v-mid" style="min-width: 57px;">
						<i
							v-if="scoreTypeIconClass(resScore.score_type)"
							class="fas fa-lg"
							:class="scoreTypeIconClass(resScore.score_type)"
							v-tippy
							:title="scoreTypeTooltip(resScore)"
						></i>
						<i
							v-if="!scoreTypeIconClass(resScore.score_type)"
							class="material-icons"
							style="font-size: 28px; line-height: 30px;"
							v-tippy
							:title="scoreTypeTooltip(resScore)"
							>{{ scoreTypeIcon(resScore.score_type) }}</i
						>
					</td>
				</tr>
				<!-- <tr v-if="!hideTime">
					<td colspan="3">
						<i class="fal fa-clock"></i> {{format(mut_score.created_at)}}
					</td>
				</tr>-->
				<tr v-for="mt in combinedMetaTraitScores" :key="mt.id">
					<td>
						<span class="text-muted">{{ getMetaTraitName(mt.id) }}:</span>
					</td>
					<td v-if="mt.first" class="b-l">
						<span class="p-1 position-relative">{{ mt.first.value }}</span>
					</td>
					<td v-if="mt.second" class="b-l">
						<span class="p-1 position-relative">{{ mt.second.value }}</span>
					</td>
					<td v-if="mt.res" class="b-l">
						<span class="p-1 position-relative">{{ mt.res.value }}</span>
					</td>
				</tr>
				<template v-if="!loading" v-for="(ts, i) in combinedTraitScores">
					<tr :key="`score-${i}`">
						<td class="v-mid">
							<strong>{{ getTraitName(ts.id) }}</strong>
						</td>
						<td v-if="ts.first" class="text-center text-lg v-mid b-l">
							<span
								class="p-1 position-relative"
								:class="{ 'text-extra-muted': getScore(ts.first) == '?' }"
								>{{ getScore(ts.first) }}</span
							>
						</td>
						<td v-if="ts.second" class="text-center text-lg v-mid b-l">
							<span
								class="p-1 position-relative"
								:class="{ 'text-extra-muted': getScore(ts.second) == '?' }"
								>{{ getScore(ts.second) }}</span
							>
						</td>
						<td v-if="ts.res" class="text-center text-lg v-mid b-l">
							<span
								class="p-1 position-relative"
								:class="{ 'text-extra-muted': getScore(ts.res) == '?' }"
								>{{ getScore(ts.res) }}</span
							>
						</td>
					</tr>
					<tr
						v-if="
							(ts.first && ts.first.evidence) ||
								(ts.second && ts.second.evidence) ||
								(ts.res && ts.res.evidence)
						"
						:key="`evidence-${i}`"
					>
						<td class="text-muted">Evidence:</td>
						<td v-if="ts.first && ts.first.evidence">{{ ts.first.evidence }}</td>
						<td v-if="ts.second && ts.second.evidence">{{ ts.second.evidence }}</td>
						<td v-if="ts.res && ts.res.evidence">{{ ts.res.evidence }}</td>
					</tr>
				</template>
				<tr v-if="loading">
					<td>
						<loading v-if="!loadingError" type="header" />
						<div v-if="loadingError">Error</div>
					</td>
				</tr>
			</tbody>
		</table>
	</div>
</template>

<script>
import Utils from "@/services/Utils";
import fs from "@/services/FormatService";
import moment from "moment";

export default {
	name: "MultiScore",
	props: {
		scores: true,
		rubric: true,
		hideTime: {
			type: Boolean,
			default: false
		}
	},
	data() {
		return {
			fs: fs,
			loading: false,
			loadingError: null,

			numAgreed: 0,
			numTraits: 0
		};
	},
	created() {},
	mounted() {},
	computed: {
		firstScore() {
			return _.find(this.scores, { score_type: 1 });
		},
		secondScore() {
			return _.find(this.scores, { score_type: 2 });
		},
		resScore() {
			return _.find(this.scores, { score_type: 3 });
		},
		combinedMetaTraitScores() {
			let mts = [];
			_.each(this.firstScore.meta_trait_scores, mt => {
				if (mt.value != "" || isRequiredMetaTrait(mt)) {
					mts.push({
						id: mt.meta_trait_id,
						first: mt
					});
				}
			});

			if (this.secondScore) {
				_.each(this.secondScore.meta_trait_scores, mt => {
					if (mt.value != "" || isRequiredMetaTrait(mt)) {
						let mti = _.findIndex(mts, { id: mt.meta_trait_id });
						if (mti > -1) {
							mts[mti].second = mt;
						}
					}
				});
			}

			if (this.resScore) {
				_.each(this.resScore.meta_trait_scores, mt => {
					if (mt.value != "" || isRequiredMetaTrait(mt)) {
						let mti = _.findIndex(mts, { id: mt.meta_trait_id });
						if (mti > -1) {
							mts[mti].res = mt;
						}
					}
				});
			}

			return mts;
		},
		combinedTraitScores() {
			let ts = [];
			_.each(this.firstScore.trait_scores, t => {
				ts.push({
					id: t.trait_id,
					first: t
				});
			});

			if (this.secondScore) {
				_.each(this.secondScore.trait_scores, t => {
					let ti = _.findIndex(ts, { id: t.trait_id });
					if (ti > -1) {
						ts[ti].second = t;
					}
				});
			}

			if (this.resScore) {
				_.each(this.resScore.trait_scores, t => {
					let ti = _.findIndex(ts, { id: t.trait_id });
					if (ti > -1) {
						ts[ti].res = t;
					}
				});
			}

			return ts;
		}
	},
	watch: {},
	methods: {
		scoreTypeIcon(scoreType) {
			return fs.scoreTypeIcon(scoreType);
		},
		scoreTypeIconClass(scoreType) {
			return fs.scoreTypeIconClass(scoreType);
		},
		scoreTypeStr(scoreType) {
			let ret = fs.scoreTypeName(scoreType);
			if (this.hasUser) {
				return `${ret}:`;
			} else {
				return ret;
			}
		},
		scoreTypeTooltip(score) {
			let tooltip = `<strong>${this.scoreTypeStr(score.score_type)} Score</strong>`;
			tooltip += `<br /><span class="text-muted"><i class="fal fa-clock"></i> ${fs.fullDate(
				score.created_at
			)}</span>`;

			return tooltip;
		},
		getTraitName(id) {
			if (this.rubric) {
				var trait = _.find(this.rubric.traits, {
					id: id
				});
				if (trait) {
					return trait.name;
				}
			}

			return "——";
		},
		getMetaTraitName(id) {
			if (this.rubric) {
				var trait = _.find(this.rubric.meta_traits, {
					id: id
				});
				if (trait) {
					return trait.name;
				}
			}

			return "——";
		},
		isRequiredMetaTrait(meta_trait) {
			if (this.rubric) {
				var trait = _.find(this.rubric.meta_traits, {
					id: meta_trait.meta_trait_id
				});
				if (trait) {
					return trait.required;
				}
			}

			return false;
		},
		getScore(ts) {
			if (ts.score >= 0) {
				return ts.score;
			} else {
				return ts.condition;
			}
		},
		messageUser() {
			this.$emit("on-message", this.score);
		},
		resetScore() {
			this.$emit("on-reset", this.score);
		}
	}
};
</script>

<style scoped>
.list-group-item:hover {
	background-color: rgba(0, 0, 0, 0.05);
}
</style>



// WEBPACK FOOTER //
// src/components/MultiScore.vue